import { Box, Container } from "@mui/material";
import { useCallback, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import SpecialityScreen from "../components/speciality-screen/speciality-screen";
import { getAllSpeciality } from "../features/speciality/specialitySlice";

const SpecialityScreens = () => {
  const dispatch = useAppDispatch();
  const { isRegisterSpecialitiesLoading, isLoading } = useAppSelector(
    (state) => state.speciality
  );

  const getSpecialities = useCallback(() => {
    dispatch(getAllSpeciality());
  }, [dispatch]);

  useEffect(() => {
    getSpecialities();
  }, [getSpecialities, isRegisterSpecialitiesLoading]);

  return (
    <>
      <Box
        sx={{
          flexGrow: 1,
          px: "1.2%",
        }}
      >
        <Box
          component="main"
          sx={{
            border: 1,
            borderColor: "divider",
            bgcolor: "white",
            borderRadius: 2,
            my: "1.2%",
            minHeight: "85vh",
            px: 3,
          }}
        >
          <Container maxWidth={false}>
            {!isLoading && (
              <Box sx={{ mt: 3 }}>
                <SpecialityScreen getSpecialities={getSpecialities} />
              </Box>
            )}
          </Container>
        </Box>
      </Box>
    </>
  );
};

export default SpecialityScreens;
